var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts"},_vm._l((_vm.list),function(ref){
var title = ref.title;
var linkTitle = ref.linkTitle;
var linkValue = ref.linkValue;
var targetBlank = ref.targetBlank;
return _c('div',{key:linkValue,staticClass:"contacts__item"},[_c('div',{staticClass:"contacts__label"},[_vm._v(" "+_vm._s(title)+" ")]),_c('a',{staticClass:"contacts__value",attrs:{"href":linkValue,"target":targetBlank ? '_blank' : null}},[_vm._v(" "+_vm._s(linkTitle)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }